import React from 'react';
import {connect} from 'react-redux';
import * as Constants from "../../Common/constants";
import { ReportFeedWidget } from '../ReportFeedWidget/ReportFeedWidget';
import { LastReportWidget } from '../LastReportWidget/LastReportWidget';
import { LeaderboardWidget } from '../LeaderboardWidget/LeaderboardWidget';

 class Dashboard extends React.Component {
    constructor(props) {

        super(props);

    }

    componentWillMount() {

    }

    componentDidMount() {
      console.log("didmount!");
    }

    componentWillReceiveProps(nextProps) {
       
    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }


    onChange(e) {

    }


    render() {
        
        console.info('Dashboard - render called.', this.props);
        return (<div><ReportFeedWidget /><LastReportWidget /><LeaderboardWidget /></div>);
        
    }
}

const mapStateToProps = state => ({
    lastitem: state.leaderboard.last
 });
 
 /**
 * Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
 * @type {{UserUpdate: UserUpdateAction}}
 */
 const mapActionsToProps = {
   
 };
 export default connect(mapStateToProps, mapActionsToProps)(Dashboard);




// WEBPACK FOOTER //
// ./src/Components/Dashboard/Dashboard.js